import axios from "axios";

export const postPaymentStatusAPI = (body: any) => {
  return axios.post(
    `${process.env.REACT_APP_ORDERING_ENDPOINT}/api/online-payment/amazon/return-url`,
    body
  );
};
